import * as actionTypes from '../../../modules/actions'

const initialState = {
  email: '',
  password: '',
  remember: false,
  errors: [],
  showPasswordResetButtonInErrorBox: false,
}

export default (state = initialState, action) => {
  switch(action.type) {
    case actionTypes.LOGIN_RESET_STATE:
      return initialState
    case actionTypes.LOGIN_UPDATE_STATE:
      return {
        ...state,
        ...action.payload,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/routes/login/modules/reducer.js